export default {"src":"/_next/static/media/arrow-left.91a038df.svg","height":16,"width":8};